export const NET_PRICE_CUSTOM_FIELD_NAME = 'netPrice';
export const DEFAULT_MONEY_TYPE = 'centPrecision';
